import React, { useEffect, useState } from "react";
import { Cleaner } from "../../../../_models/Cleaner.model";
import { getAllCleaners } from "../../../../_utils/resourceAPI";
import { UpdateCleaner } from "../UpdateCleaner/UpdateCleaner";
import { useCleanerContext } from "../../../../_context/CleanerContext";
import { CleanerUpdatedSuccessModal } from "../UpdateCleaner/CleanerUpdatedSuccessModal";
import { CleanerDeleteSuccessModal } from "../UpdateCleaner/ClientDeletedSuccessModal";

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const AddedCleaners = () => {
  const [allCleaners, setAllCleaners] = useState<Cleaner[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { setCleanerUpdated, setCleanerDeleted, cleanerUpdated } = useCleanerContext();

  const fetchCleaners = () => {
    getAllCleaners()
      .then(res => setAllCleaners(res.data || []))
      .catch(() => console.log("Failed to fetch cleaners"));
  };

  useEffect(() => { fetchCleaners(); }, []);

  useEffect(() => {
    if (cleanerUpdated) { fetchCleaners(); setCleanerUpdated(false); }
  }, [cleanerUpdated, setCleanerUpdated]);

  const onCleanerUpdate = () => { fetchCleaners(); setCleanerUpdated(true); };
  const onCleanerDelete = () => { fetchCleaners(); setCleanerDeleted(true); };

  const filteredCleaners = (allCleaners || []).filter(c =>
    c.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.Phone.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.Email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Search */}
      <div className="au-search-wrap">
        <span className="au-search-icon"><SearchIcon /></span>
        <input
          type="text"
          className="au-search-input"
          placeholder="Search by name, phone or email…"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredCleaners.length === 0 ? (
        <div className="au-empty">No cleaners found</div>
      ) : (
        <div className="au-table-wrap">
          <table className="au-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredCleaners.map(cleaner => cleaner ? (
                <tr key={cleaner.Id}>
                  <td data-label="Name"><span className="truncate-text">{cleaner.Name}</span></td>
                  <td data-label="Phone" style={{ color: "#6B7280" }}><span className="truncate-text">{cleaner.Phone}</span></td>
                  <td data-label="Email" style={{ color: "#6B7280" }}><span className="truncate-text">{cleaner.Email}</span></td>
                  <td data-label="Action">
                    <UpdateCleaner
                      existingCleaner={cleaner}
                      onCleanerupdate={onCleanerUpdate}
                      onCleanerDelete={onCleanerDelete}
                    />
                  </td>
                </tr>
              ) : null)}
            </tbody>
          </table>
        </div>
      )}

      <CleanerUpdatedSuccessModal />
      <CleanerDeleteSuccessModal />
    </div>
  );
};
